import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { Link } from "react-router-dom";

export default function RefundPolicyPage() {
  return (
    <LegalLayout title="Refund Policy" updated="June 1, 2026" current="/refund-policy">
      <p>
        This Refund Policy applies to business clients subscribing to the NextGen Resolution Experts platform under
        our <Link to="/service-agreement" className="text-blue-600 hover:underline">Service Agreement</Link>. It has
        two parts: our policy toward you (the Client), and guidance on the refund policy you offer your own
        customers.
      </p>

      <LegalSection heading="Part 1 — Refunds for Clients of NextGen Resolution Experts">
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Setup fee ($499) — non-refundable.</strong> The setup fee covers onboarding, configuration, and
            implementation work that is performed immediately upon signup. Once onboarding has begun, this fee is
            non-refundable.
          </li>
          <li>
            <strong>Monthly subscription fees ($499 / 30 days) — non-refundable once the billing period has
            started.</strong> When a new 30-day period begins, the fee for that period is earned in full and will
            not be prorated or refunded, including upon cancellation mid-period.
          </li>
          <li>
            <strong>Cancellation:</strong> to avoid being charged for a future period, provide written cancellation
            notice at least 30 days in advance, per the Service Agreement.
          </li>
          <li>
            <strong>Billing errors:</strong> if you believe you were charged in error (e.g., a duplicate charge),
            contact us within 30 days of the charge and we will investigate and correct verified errors promptly.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="Part 2 — Your Customers' Refund Policy (Client-Configured)">
        <p>
          If you use the NextGen Resolution Experts helpdesk to support your own customers, any refund policy shown
          or referenced to those customers (for example, a "30-day money-back guarantee") is <strong>your policy,
          not ours</strong>. You are solely responsible for:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Defining and publishing your own customer refund terms;</li>
          <li>Configuring your knowledge base and AI assistant guidance to reflect those terms;</li>
          <li>Reviewing and approving any refund before it is issued to your customer.</li>
        </ul>
        <p>
          <strong>Important:</strong> AI assistant responses do not constitute an approved refund. Per our{" "}
          <Link to="/terms" className="text-blue-600 hover:underline">Terms of Service</Link> and Service Agreement,
          NextGen Resolution Experts is not liable for any refund the AI assistant incorrectly suggests or approves.
          Final refund decisions always rest with an authorized human representative of your business.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Refund or billing questions:{" "}
          <a href="mailto:support@nextgenresolutionexperts.com" className="text-blue-600 hover:underline">
            support@nextgenresolutionexperts.com
          </a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
